import { createFileRoute } from '@tanstack/react-router';
import { BillPage } from '@/features/checkout/pages/bill-page';

export const Route = createFileRoute('/_app/checkout/$billId/')({ component: BillRoute });

function BillRoute() {
  const { billId } = Route.useParams();
  return <BillPage billId={billId} />;
}
